import type { IconProps } from "./icon-types";

/**
 * 돋보기. Dropdown 검색 입력 등에서 사용.
 */
export const SearchIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
    <circle cx="7" cy="7" r="4" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M10.2 10.2 13 13"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
